exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".editDescriptionDialog {\n  position: absolute;\n  z-index: 300;\n  width: 320px;\n  -webkit-transition: all 300ms linear;\n  transition: all 300ms linear;\n}\n", ""]);
